import * as React from "react";

import {t} from "i18next";

import {Table, Label, Tab, Icon, Checkbox, Pagination, Segment, Flag} from "semantic-ui-react";
import Button from "../../../components/Button";

import {DerivateUtils} from "../../../components/Table/components/derivate/DerivateUtils";
import DataAdapterOptionsView from "../DataAdapterOptionsView";
import {ModeltypeBasicDto, OptionTextDto, OptionDto, AssignedModeltypeBasicDtoAssignmentType} from "../../../services/Client";
import {SelectAction} from "./AMTBTransferUtils";
import PromtFormatter from "src/components/Table/components/reactQuill/PromtFormatter";

interface ISummaryAMTBTransferDialogProps {
    sourceMTB: ModeltypeBasicDto;
    targetMTBs: ModeltypeBasicDto[];
    initialWfStepItems: DataAdapterOptionsView[];
    startedWfItems: DataAdapterOptionsView[];
    invalidItems: DataAdapterOptionsView[];
    transferItems: OptionDto[];
    userLanguage: string;

    handleSelectChange: (item: DataAdapterOptionsView[], actionType: number) => void;
    nextAction: () => void;
    backAction: () => void;
}

interface ISummaryAMTBTransferDialogState {
    startedWfTab: number;
    initialWfTab: number;
    invalidAssigmentsTab: number;
}

export class SummaryAMTBTransferDialog extends React.Component<ISummaryAMTBTransferDialogProps, ISummaryAMTBTransferDialogState> {

    constructor(props: ISummaryAMTBTransferDialogProps) {
        super(props);

        this.state = {
            startedWfTab: 1,
            initialWfTab: 1,
            invalidAssigmentsTab: 1,
        };
    }

    componentDidUpdate(prevProps: Readonly<ISummaryAMTBTransferDialogProps>): void {
        if (prevProps.sourceMTB !== this.props.sourceMTB
            || prevProps.targetMTBs !== this.props.targetMTBs) {
            this.setState({
                startedWfTab: 1,
                initialWfTab: 1,
                invalidAssigmentsTab: 1
            });
        }
    }

    getInvalidTab = (itemsTotal: DataAdapterOptionsView[]): JSX.Element => {
        const items = itemsTotal.slice((this.state.invalidAssigmentsTab - 1) * 10, this.state.invalidAssigmentsTab * 10);
        return (
            <Table
                celled={true}
                structured={true}
                textAlign={"center"}
            >
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell rowSpan={2}>{t("AMTB_TRANSFER:OPTION_IDENTIFIER")}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan={2}>{t("AMTB_TRANSFER:SHORTTEXT")}</Table.HeaderCell>
                        <Table.HeaderCell>{t("AMTB_TRANSFER:SOURCE_ASSIGNMENT")}</Table.HeaderCell>
                        <Table.HeaderCell colSpan={this.props.targetMTBs.length}>{t("AMTB_TRANSFER:TARGET_ASSIGNMENTS")}</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>{DerivateUtils.renderKeyDerivate(this.props.sourceMTB, this.props.userLanguage)}</Table.HeaderCell>
                        {this.props.targetMTBs.map((mtb, index) =>
                            <Table.HeaderCell key={'target-mtb-' + index}>
                                {DerivateUtils.renderKeyDerivate(mtb, this.props.userLanguage)}
                            </Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {items.map((item: DataAdapterOptionsView, index: number) => {
                        return (
                            <Table.Row key={'row-' + index}>
                                <Table.Cell>
                                    <Label size={'large'} className={'whitespace--nowrap'}>
                                        {item.optionBasicView}
                                        <Label.Detail>
                                            {item.optionTypeView}
                                        </Label.Detail>
                                    </Label>
                                </Table.Cell>
                                <Table.Cell>
                                    <Segment.Group horizontal={true}>
                                        {item.texts.sort((a, b) =>
                                            (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                                            .map((txt: OptionTextDto, idx: number) =>
                                                <Segment
                                                    key={"txt-" + idx}
                                                    className={'amtb-transfer-text-segment'}
                                                >
                                                    <Flag
                                                        name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                                                        className={'amtb-transfer-text-flag'}

                                                    />
                                                    {txt.shorttext || ""}
                                                </Segment>
                                            )}
                                    </Segment.Group>
                                </Table.Cell>
                                <Table.Cell>
                                    {DerivateUtils.getAMTBIcon(item.dto.modeltypes || [], this.props.sourceMTB)}
                                </Table.Cell>
                                {this.props.targetMTBs.map((mtb, idx) =>
                                    <Table.Cell key={'target-amtb-' + idx}>{DerivateUtils.getAMTBIcon(item.dto.modeltypes || [], mtb)}</Table.Cell>
                                )}
                            </Table.Row>
                        );
                    })}
                </Table.Body>

                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan={3 + this.props.targetMTBs.length}>
                            <Pagination
                                activePage={this.state.invalidAssigmentsTab}
                                totalPages={Math.ceil(itemsTotal.length / 10)}
                                onPageChange={(e, c) => this.setState({invalidAssigmentsTab: c.activePage as number})}
                            />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        );
    }

    getTabTable = (itemsTotal: DataAdapterOptionsView[], startedWfItems: boolean): JSX.Element => {
        const allSelected = itemsTotal.every((val) => this.props.transferItems.some((e: OptionDto) => e.objectId === val.dto.objectId));
        const items = startedWfItems
            ? itemsTotal.slice((this.state.startedWfTab - 1) * 10, this.state.startedWfTab * 10)
            : itemsTotal.slice((this.state.initialWfTab - 1) * 10, this.state.initialWfTab * 10);

        return (
            <Table
                celled={true}
                structured={true}
                textAlign={"center"}
            >
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell rowSpan={2}>
                            <Checkbox
                                slider={true}
                                checked={allSelected}
                                onChange={() => allSelected
                                    ? this.props.handleSelectChange(itemsTotal, SelectAction.DeselectAll)
                                    : this.props.handleSelectChange(itemsTotal, SelectAction.SelectAll)}
                            />
                        </Table.HeaderCell>
                        <Table.HeaderCell rowSpan={2}>{t("AMTB_TRANSFER:OPTION_IDENTIFIER")}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan={2}>{t("AMTB_TRANSFER:SHORTTEXT")}</Table.HeaderCell>
                        <Table.HeaderCell>{t("AMTB_TRANSFER:SOURCE_ASSIGNMENT")}</Table.HeaderCell>
                        <Table.HeaderCell colSpan={this.props.targetMTBs.length}>{t("AMTB_TRANSFER:TARGET_ASSIGNMENTS")}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan={2}>{t("AMTB_TRANSFER:PREVIEW_ASSIGNMENTS")}</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>{DerivateUtils.renderKeyDerivate(this.props.sourceMTB, this.props.userLanguage)}</Table.HeaderCell>
                        {this.props.targetMTBs.map((mtb, index) =>
                            <Table.HeaderCell key={'target-mtb-' + index}>
                                {DerivateUtils.renderKeyDerivate(mtb, this.props.userLanguage)}
                            </Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {items.map((item: DataAdapterOptionsView, index: number) => {
                        let isLastStep = false;
                        const statusValueState = item.statusValueState;
                        const getWorkFlow = item.workflows.find(
                            (p) => p.name === item.workFlowName
                        );
                        if (getWorkFlow && getWorkFlow.status) {
                            const getCurrentWFName = getWorkFlow.status.find(
                                (p) => p.objectId === statusValueState
                            );
                            if (
                                getCurrentWFName &&
                                getCurrentWFName.sequenceNumber === 5
                            ) {
                                isLastStep = true;
                            }
                        }

                        return (
                            <Table.Row key={'row-' + index}>
                                <Table.Cell>
                                    <Checkbox
                                        slider={true}
                                        checked={this.props.transferItems.some((e: OptionDto) => e.objectId === item.dto.objectId)}
                                        onChange={() => this.props.handleSelectChange([item], SelectAction.SingleSelect)}
                                    />
                                </Table.Cell>
                                <Table.Cell>
                                    <Label size={'large'} className={'whitespace--nowrap'}>
                                        {item.optionBasicView}
                                        <Label.Detail>
                                            {item.optionTypeView}
                                        </Label.Detail>
                                    </Label>
                                </Table.Cell>
                                <Table.Cell>
                                    <Segment.Group horizontal={true}>
                                        {item.texts.sort((a, b) =>
                                            (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                                            .map((txt: OptionTextDto, idx: number) =>
                                                <Segment
                                                    key={"txt-" + idx}
                                                    className={'amtb-transfer-text-segment'}
                                                >
                                                    <Flag
                                                        name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                                                        className={'amtb-transfer-text-flag'}

                                                    />
                                                    {txt.shorttext || ""}
                                                </Segment>
                                            )}
                                    </Segment.Group>
                                </Table.Cell>
                                <Table.Cell>
                                    {DerivateUtils.getAMTBIcon(item.dto.modeltypes || [], this.props.sourceMTB)}
                                </Table.Cell>
                                {this.props.targetMTBs.map((mtb, idx) =>
                                    <Table.Cell key={'target-amtb-' + idx}>{DerivateUtils.getAMTBIcon(item.dto.modeltypes || [], mtb)}</Table.Cell>
                                )}
                                <Table.Cell>
                                    {DerivateUtils.getPreviewAMTBIcon(item.dto.modeltypes || [], this.props.sourceMTB, isLastStep)}
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>

                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan={5 + this.props.targetMTBs.length}>
                            <Pagination
                                activePage={startedWfItems ? this.state.startedWfTab : this.state.initialWfTab}
                                totalPages={Math.ceil(itemsTotal.length / 10)}
                                onPageChange={(e, c) =>
                                    startedWfItems
                                        ? this.setState({startedWfTab: c.activePage as number})
                                        : this.setState({initialWfTab: c.activePage as number})
                                }
                            />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        );
    }

    getTabs = () => {
        const tabs = [];

        if (this.props.startedWfItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'wf-started-tab',
                    className: 'amtb-transfer-wf-started-tab',
                    content: (
                        <b style={{color: 'orange'}}>{t("AMTB_TRANSFER:WF_STARTED_TAB")}</b>
                    )
                },
                render: () => this.getTabTable(this.props.startedWfItems, true)
            });
        }

        if (this.props.initialWfStepItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'initial-wf-step-tab',
                    className: 'amtb-transfer-initial-wf-step-tab',
                    content: (
                        <b style={{color: 'green'}}>{t("AMTB_TRANSFER:INITIAL_WF_TAB")}</b>
                    )
                },
                render: () => this.getTabTable(this.props.initialWfStepItems, false)
            });
        }

        if (this.props.invalidItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'invalid-tab',
                    className: 'amtb-transfer-invalid-tab',
                    content: (
                        <b style={{color: 'red'}}>{t("AMTB_TRANSFER:INVALID_ITEMS_TAB")}</b>
                    )
                },
                render: () => this.getInvalidTab(this.props.invalidItems),
            });
        }

        return tabs;
    }

    render() {
        const totalItemsCount = this.props.startedWfItems.length + this.props.initialWfStepItems.length + this.props.invalidItems.length;

        return (
            <>
                <div style={{marginBottom: '20px'}}>
                    <p>
                        <b>{totalItemsCount}</b>
                        {' ' + t(totalItemsCount === 1 ? "AMTB_TRANSFER:ALL_ITEMS_COUNT_SINGLE" : "AMTB_TRANSFER:ALL_ITEMS_COUNT_MULTI")}
                    </p>

                    {this.props.startedWfItems.length > 0 &&
                        <p>
                            <b style={{color: 'orange'}}>{this.props.startedWfItems.length}</b>
                            {' ' + t(this.props.startedWfItems.length === 1 ? "AMTB_TRANSFER:WF_STARTED_COUNT_SINGLE" : "AMTB_TRANSFER:WF_STARTED_COUNT_MULTI") +
                                ' ' + t("AMTB_TRANSFER:WF_STARTED_COUNT_TXT", {tab: t("AMTB_TRANSFER:WF_STARTED_TAB")})}
                        </p>
                    }

                    {this.props.initialWfStepItems.length > 0 &&
                        <p>
                            <b style={{color: 'green'}}>{this.props.initialWfStepItems.length}</b>
                            {' ' + t(this.props.initialWfStepItems.length === 1 ? "AMTB_TRANSFER:INITIAL_WF_COUNT_SINGLE" : "AMTB_TRANSFER:INITIAL_WF_COUNT_MULTI") +
                                ' ' + t("AMTB_TRANSFER:INITIAL_WF_COUNT_TXT", {tab: t("AMTB_TRANSFER:INITIAL_WF_TAB")})}
                        </p>
                    }

                    {this.props.invalidItems.length > 0 &&
                        <div className={"display--flex"}>
                            <Icon name="warning sign" color="red" />
                            <p>
                                <b style={{color: 'red'}}>{this.props.invalidItems.length}</b>
                                {' ' +
                                    t(this.props.invalidItems.length === 1 ? "AMTB_TRANSFER:INVALID_ITEMS_COUNT_SINGLE" : "AMTB_TRANSFER:INVALID_ITEMS_COUNT_MULTI", {
                                        type: t("OPTIONS_VIEW:" + AssignedModeltypeBasicDtoAssignmentType.SV)
                                    }) + ' ' + t("AMTB_TRANSFER:INVALID_ITEMS_COUNT_TXT", {tab: t("AMTB_TRANSFER:INVALID_ITEMS_TAB")})
                                }
                            </p>
                        </div>
                    }
                </div>

                <Tab
                    panes={this.getTabs()}
                    menu={{pointing: true}}
                    className={'scrollbarX'}
                />

                <div style={{marginTop: '30px'}}>
                    <Button
                        icon={'arrow left'}
                        onClick={this.props.backAction}
                    />
                    {(this.props.initialWfStepItems.length > 0 || this.props.startedWfItems.length > 0) &&
                        <div style={{float: 'right'}}>
                            {this.props.transferItems.length < 1 &&
                                <Label color={'red'} pointing={'right'}>
                                    <Icon name={'warning'} />
                                    {t("AMTB_TRANSFER:EMPTY_LIST_HINT")}
                                </Label>}
                            <Button
                                icon={'arrow right'}
                                style={{float: 'right'}}
                                disabled={this.props.transferItems.length < 1}
                                onClick={this.props.nextAction}
                            />
                        </div>
                    }
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/amtbTransfer/SummaryAMTBTransferDialog.tsx